export default "__VITE_PUBLIC_ASSET__962ef7e5__"